import { Trans } from '@lingui/react/macro';
import { Box, Button, ScrollArea, Typography } from '@pocketlaw/tetris';
import { Link, useRouteMatch } from 'react-router-dom';
import { RerunWorkflowButton } from 'app/domains/workflows/features/RerunWorkflowButton';
import { WorkflowCheckError } from 'app/domains/workflows/features/WorkflowCheckError';
import { WorkflowCheckOutdatedMessage } from 'app/domains/workflows/features/WorkflowCheckOutdatedMessage';
import { useWorkflowCheck } from 'app/domains/workflows/features/WorkflowCheckProvider';
import { Falcon } from 'modules/macro';
import { AskForApprovalButton } from './AskForApprovalButton';
import { ManualApprovers } from './ManualApprovers';
import { useWorkflowApprovers } from './WorkflowApproversProvider';
import { AdvancedApprovalCheckPreview } from '../../../AdvancedApprovalCheckPreview';
import { ActionsFooter, Content, Container, InnerContent } from './styled';
export function ReviewState() {
    const { approvalResult } = useWorkflowCheck();
    const { summary, isApprovalRequired, approvers } = approvalResult;
    const { selectedApproverIds, toggleApprover } = useWorkflowApprovers();
    const { url } = useRouteMatch();
    const esigningUrl = url.replace('/approval', '/esigning');
    const suggestedApprovers = approvers.map((approver) => (Object.assign(Object.assign({}, approver), { selected: selectedApproverIds.includes(approver.id), onChange: () => toggleApprover(approver) })));
    return (<Container>
      <Content>
        <ScrollArea>
          <InnerContent>
            <WorkflowCheckError />

            <AdvancedApprovalCheckPreview isApprovalRequired={isApprovalRequired} summary={summary} approvers={suggestedApprovers}/>

            {!isApprovalRequired && (<Box alignItems="center" gap="md" p="lg" borderRadius="md" bg="background.75">
                <Falcon icon="info-circle"/>
                <Typography $fontSize="small" $appearance="300">
                  <Trans comment="Approval workflow check - Approval is not required">Approval is not required</Trans>
                </Typography>
                <Box ml="auto">
                  <Button as={Link} to={esigningUrl} appearance="primary" size="xs">
                    <Trans comment="Approval workflow check - Go to eSigning">Go to eSigning</Trans>
                    <Falcon icon="arrow-right"/>
                  </Button>
                </Box>
              </Box>)}

            <ManualApprovers />
          </InnerContent>
        </ScrollArea>
      </Content>

      <ActionsFooter>
        <Box flexDirection="column" gap="md">
          <WorkflowCheckOutdatedMessage />
          <Box gap="md">
            <RerunWorkflowButton />
            <AskForApprovalButton />
          </Box>
        </Box>
      </ActionsFooter>
    </Container>);
}
